import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/Text';
import PlayerDialog from '@cartwhl/ui/molecules/PlayerDialog';

import { animationGenerationStore } from 'stores';

// deprecated: with the timeline update we move to ready states
export default function StageLoader() {
  const { loading } = useSnapshot(animationGenerationStore.state);
  const isLoading =
    loading.init || loading.animation || loading.mesh || loading.data;

  if (!isLoading) return null;

  const text = loading.init
    ? 'Initializing system'
    : loading.data
      ? 'Fetching data'
      : loading.animation
        ? 'Preparing animation'
        : 'Updating character';

  return (
    <PlayerDialog maxWidth={240}>
      <div className="flex flex-col items-center">
        <svg
          width="40"
          height="40"
          className="text-green animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            className="stroke-gray-30 dark:stroke-gray-60"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>

        <Text variant="studio/body/sm" className="mt-6">
          {text}
        </Text>
      </div>
    </PlayerDialog>
  );
}
